import { supabase } from "./supabase";

function extensionFor(file) {
  const fromName = file.name?.split(".").pop()?.toLowerCase();
  if (fromName && /^[a-z0-9]+$/.test(fromName)) return fromName;
  if (file.type === "image/jpeg") return "jpg";
  if (file.type === "image/png") return "png";
  if (file.type === "image/webp") return "webp";
  if (file.type === "image/gif") return "gif";
  return "jpg";
}

/** Upload to public.avatars at {userId}/avatar.{ext}; returns cache-busted public URL. */
export async function uploadAvatar(userId, file) {
  const ext = extensionFor(file);
  const path = `${userId}/avatar.${ext}`;

  const { error: uploadError } = await supabase.storage
    .from("avatars")
    .upload(path, file, {
      upsert: true,
      contentType: file.type || "image/jpeg",
      cacheControl: "3600",
    });

  if (uploadError) throw uploadError;

  const { data } = supabase.storage.from("avatars").getPublicUrl(path);
  const base = data?.publicUrl;
  if (!base) throw new Error("Failed to resolve avatar public URL");
  return `${base}?t=${Date.now()}`;
}

/** Delete all objects under {userId}/ in the avatars bucket. */
export async function removeAvatar(userId) {
  const { data: listed, error: listError } = await supabase.storage
    .from("avatars")
    .list(userId);

  if (listError) throw listError;
  if (!listed?.length) return;

  const paths = listed.map((obj) => `${userId}/${obj.name}`);
  const { error: removeError } = await supabase.storage
    .from("avatars")
    .remove(paths);

  if (removeError) throw removeError;
}

export async function upsertProfile(payload) {
  const { data, error } = await supabase
    .from("profiles")
    .upsert(payload, { onConflict: "id" })
    .select("*")
    .single();

  if (error) throw error;
  return data;
}
